import * as React from "react"

const TransOrderManagement = (props) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.056 2.25a.75.75 0 0 1 .658.389l2.693 4.902a.75.75 0 0 1 .093.361V12H21V8.25H3v12h10.5v1.5H2.25A.75.75 0 0 1 1.5 21V7.902a.75.75 0 0 1 .093-.36l2.693-4.903a.75.75 0 0 1 .658-.389h14.112ZM9 16.5v2.25H4.5V16.5H9Zm2.25-12.75H5.385l-1.647 3h7.512v-3Zm7.363 0H12.75v3h7.511l-1.648-3Z"
      fill="#80B8EE"
    />
    <path
      d="m22.28 18.28.063-.07a.75.75 0 0 0-.063-.99l-3-3-.07-.063a.75.75 0 0 0-.99.063l-.063.07a.75.75 0 0 0 .063.99L19.939 17H15.75l-.088.005a.75.75 0 0 0 .088 1.495h4.189l-1.72 1.72-.062.07a.75.75 0 0 0 1.123.99l3-3Z"
      fill="#80B8EE"
    />
  </svg>
)

export default TransOrderManagement;
